import { __extends } from "tslib";
import ContentViewModel from './ContentViewModel';
import React from 'react';
import { Route, Redirect, Switch } from 'react-router';
import Application from './Application';
import Managers from '../../Architecture/Managers/Constants/Managers';
var ContentShellViewModel = /** @class */ (function (_super) {
    __extends(ContentShellViewModel, _super);
    function ContentShellViewModel(view) {
        var _this = _super.call(this, view) || this;
        _this.basePath = "/:language/";
        _this.dictionnaryJSX = new Map();
        return _this;
    }
    ContentShellViewModel.prototype.getSwitch = function () {
        return this.routes;
    };
    ContentShellViewModel.prototype.initialisation = function () {
        this.routes = this.constructSwitch();
    };
    /*
    * Register a Entry Point for the Switch.
    *
    */
    ContentShellViewModel.prototype.registerEntryPoint = function (baseName) {
        this.entryPoint = baseName;
    };
    /*
    * Register a JSX.ELEMENT for a module.
    *
    */
    ContentShellViewModel.prototype.register = function (view, stringtonavigate) {
        var moduleId = this.getModuleId();
        if (moduleId != undefined) {
            var theModule = Application.current.resolve(Managers.MODULE_MANAGER).resolveModuleById(moduleId);
            if (theModule != undefined) {
                this.moduleName = theModule;
                this.moduleId = moduleId;
                this.dictionnaryJSX.set(stringtonavigate, view);
            }
            else {
                console.warn("The module is not registred : " + moduleId);
            }
        }
        else {
            console.warn("You need to implement getModuleId");
        }
    };
    /*
    *
    * Construct the Switch with differents routes
    *
    */
    ContentShellViewModel.prototype.constructSwitch = function () {
        var _this = this;
        var routes = [];
        this.dictionnaryJSX.forEach(function (value, key) {
            routes.push(_this.constructRoute(key, value));
        });
        var path = this.basePath + this.moduleName;
        routes.push(React.createElement(Route, { path: path, render: function () { return React.createElement(Redirect, { to: "/" + Application.current.resolve(Managers.LANGUAGE_MANAGER).language + "/" + _this.moduleName + "/" + _this.entryPoint }); } }));
        return (React.createElement(Switch, null, routes));
    };
    ContentShellViewModel.prototype.constructRoute = function (namepage, element) {
        var _this = this;
        var path = this.basePath + this.moduleName + "/" + namepage;
        return React.createElement(Route, { path: path, render: function () { return React.cloneElement(element, { module: _this.moduleName }); } });
    };
    return ContentShellViewModel;
}(ContentViewModel));
export default ContentShellViewModel;
